"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontFamilies;
(function (FontFamilies) {
    FontFamilies["HELVETICA"] = "'Segoe UI', 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif";
    FontFamilies["TIMES_NEW_ROMAN"] = "'Times New Roman', Times, Baskerville, Georgia, serif";
    FontFamilies["ATKINSON"] = "Atkinson Hyperlegible";
    FontFamilies["KARLA"] = "Karla";
    FontFamilies["INTER"] = "Inter";
    FontFamilies["KHAND"] = "Khand";
    FontFamilies["KRUB"] = "Krub";
    FontFamilies["MONTSERRAT"] = "Montserrat";
    FontFamilies["MONTSERRAT_ALTERNATES"] = "Montserrat Alternates";
    FontFamilies["NOTO_SANS"] = "Noto Sans";
    FontFamilies["OPEN_SANS"] = "Open Sans";
    FontFamilies["OSWALD"] = "Oswald";
    FontFamilies["PT_SANS"] = "PT Sans";
    FontFamilies["QUICKSAND"] = "Quicksand";
    FontFamilies["RALEWAY"] = "Raleway";
    FontFamilies["ROBOTO"] = "Roboto";
    FontFamilies["ROSARIO"] = "Rosario";
    FontFamilies["RUBIK"] = "Rubik";
    FontFamilies["WORK_SANS"] = "Work Sans";
    FontFamilies["BASKERVILLE"] = "Baskerville";
    FontFamilies["BITTER"] = "Bitter";
    FontFamilies["CORMORANT"] = "Cormorant";
    FontFamilies["CRIMSON_PRO"] = "Crimson Pro";
    FontFamilies["GENTIUM_BOOK_BASIC"] = "Gentium Book Basic";
    FontFamilies["NOTO_SERIF"] = "Noto Serif";
    FontFamilies["PLAYFAIR_DISPLAY"] = "Playfair Display";
    FontFamilies["QUATTROCENTO"] = "Quattrocento";
    FontFamilies["ROBOTO_SLAB"] = "Roboto Slab";
    FontFamilies["VOLLKORN"] = "Vollkorn";
    FontFamilies["ZILLA_SLAB"] = "Zilla Slab";
})(FontFamilies || (FontFamilies = {}));
exports.default = FontFamilies;
//# sourceMappingURL=FontFamilies.js.map